import { $ModuleArea, GymMode, ModuleArea } from '@suntex.fim/enums';

import { NodeModel } from '../../../types';
import { buildGymModeNode } from '../../utils/buildGymNode';

const moduleAreaDesc = $ModuleArea.describe(ModuleArea.Gyms);

export const gymsNode: NodeModel = {
  tag: moduleAreaDesc.slug,
  info: {
    title: moduleAreaDesc.label,
  },
  label: {
    aria: moduleAreaDesc.label,
    class: 'MainLabel',
    frame: 3,
  },
  color: moduleAreaDesc.color,
  layout: 'modes',
  children: [
    GymMode.WholeNumbers,
    GymMode.Fractions,
    GymMode.Decimals,
    GymMode.Integers,
  ].map((gymMode) => buildGymModeNode(gymMode)),
};
